import getCmdOrCtrl from 'shared/foreground/utils/getCmdOrCtrl';

export const getActionKey = (): string => {
  return getCmdOrCtrl() === 'cmd' ? '⌘' : 'ctrl';
};
